import { AutogenModelCurrentUserPowerbroker, AutogenRowCurrentUserPowerbroker } from "./autogen/AutogenModelCurrentUserPowerbroker";

export class ModelCurrentUserPowerbroker extends AutogenModelCurrentUserPowerbroker<RowCurrentUserPowerbroker> {
    constructor() {
        super(RowCurrentUserPowerbroker);
    }
}

export class RowCurrentUserPowerbroker extends AutogenRowCurrentUserPowerbroker {
}